export default {
    path: 'data',
    name: 'data',
    component: () => import(/* webpackChunkName: "revenue-list" */ '@/pages/data/Index'),
    meta: {title: '数据管理'},
}
